export enum ROUTE {
  HOME_PAGE = "/",
  LOGIN = "/login",
  DOCUMENT_UPLOAD = "/doc-upload",
  OPPORTUNITY_CREATE = "/opportunity-create",
  HOME_PAGE_1 = "/home-page-1",
}
